module.exports = __webpack_public_path__ + "static/tryhard-japan-white-new2-ea3bb6058235651a75b0dcab18b67346.png";